import { useCallback, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { adminAuthHeaders } from "@/components/AdminGate";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EMPTY_FORM = { name: "", category: "", code: [], categories: [] };

export default function useNewStratagemForm(onCreated) {
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);
  const [categoryInput, setCategoryInput] = useState("");

  const reset = useCallback(() => {
    setForm(EMPTY_FORM);
    setCategoryInput("");
    setShowModal(false);
  }, []);

  const addDirection = useCallback(
    (d) => setForm((p) => ({ ...p, code: [...p.code, d] })),
    [],
  );
  const removeLastDirection = useCallback(
    () => setForm((p) => ({ ...p, code: p.code.slice(0, -1) })),
    [],
  );
  const clearDirections = useCallback(
    () => setForm((p) => ({ ...p, code: [] })),
    [],
  );

  const addCategory = useCallback(() => {
    const cat = categoryInput.trim();
    if (!cat) return;
    setForm((p) => {
      if (p.categories.includes(cat)) return p;
      return { ...p, categories: [...p.categories, cat] };
    });
    setCategoryInput("");
  }, [categoryInput]);

  const removeCategory = useCallback(
    (cat) => setForm((p) => ({ ...p, categories: p.categories.filter((c) => c !== cat) })),
    [],
  );

  const create = useCallback(async () => {
    const name = form.name.trim();
    if (!name) { toast.error("Name is required."); return; }
    if (form.code.length === 0) { toast.error("Code sequence is required."); return; }
    try {
      await axios.post(
        `${API}/stratagems`,
        {
          name,
          code: form.code,
          category: form.category.trim() || "Other",
          categories: form.categories.length > 0 ? form.categories : undefined,
        },
        { headers: adminAuthHeaders() },
      );
      toast.success(`${name} added successfully.`);
      reset();
      if (onCreated) onCreated();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Unable to create stratagem.");
    }
  }, [form, reset, onCreated]);

  return {
    showModal, setShowModal,
    form, setForm,
    categoryInput, setCategoryInput,
    reset,
    addDirection, removeLastDirection, clearDirections,
    addCategory, removeCategory,
    create,
  };
}
